import { Injectable, } from '@angular/core';
import { map, catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Session, AddressOP } from '../interfaces';
import { Department, District } from '../models';
import { ApiService } from './api.service';
import { getIdAddress } from '../helpers/util';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  private listDistrict: any[];
  constructor(
    private apiService: ApiService
  ) {
    this.listDistrict = [];
  }
  read(...arg): Observable<any> {
    if (arg.length) {
      switch (arg[0]) {
        case 'department':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/departments`)
            .pipe(map(data => data));

        case 'province':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/departments/${arg[1]}?limit=100&offset=0`)
            .pipe(map(data => data));

        case 'district':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/?
            department=${arg[1].department}&
            province=${arg[1].province}&
            sub_zones=${arg[1].sub_zones}&
            special_zones=${arg[1].special_zones}&
            filter_actives=${arg[1].filter_actives} &
            geo_json=${arg[1].geo_json} &
            sale_channel=${arg[1].sale_channel} &
            dispatch_enabled=${arg[1].dispatch_enabled}`.replace(/\t|\n|\s+/g, ''))
            .pipe(map(data => data));

        case 'zones-sub-special':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/?${arg[1]}`.replace(/\t|\n|\s+/g, ''))
            .pipe(map(data => data));

        case 'zones-sub-special-department':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/?${arg[1]}`.replace(/\t|\n|\s+/g, ''))
            .pipe(map(data => data));

        case 'zones-sub-special-province':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/?${arg[1]}`.replace(/\t|\n|\s+/g, ''))
            .pipe(map(data => data));

        case 'districtCode':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/${arg[1]}`)
            .pipe(map(data => data));
        case 'districtPartial':
          return this.apiService
            .get(`${this.apiService.dispatchZone}/districts/?partial_district=${arg[1]}&geo_json=${arg[2]}`)
            .pipe(map(data => data));

      }
    }
    return of(null);

  }

  getZoneByUbigeoCode(ubigeo, saleChannel = null): Observable<any> {
    return this.apiService
      .get(`${this.apiService.dispatchZone}/districts/?ubigeo_code=${ubigeo}&add_relations=true&sale_channel=${saleChannel}`)
      .pipe(map(data => {
        return data;
      }));
    /* const session: Session = JSON.parse(localStorage.getItem(environment.sessionAuth));
    if (session && session.zoneEntity && session.zoneEntity.length) {
      return of(session.zoneEntity);
    } else {
      session.zoneEntity = [];
      session.zoneEntity = data;
      localStorage.setItem(environment.sessionAuth, JSON.stringify(session));
    } */
  }

  getZoneForUbigeo(ubigeo): Observable<any> {
    return this.apiService
      .get(`${this.apiService.dispatchZone}/districts/?ubigeo_code=${ubigeo}&add_relations=true`)
      .pipe();
  }

  _filterDepartment(): Observable<Department[]> {
    const session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (
      session &&
      session.departments) {
      return of(session.departments);
    } else {
      return this.read('department').pipe(
        map((response: any) => {
          session.departments = [];
          session.departments = response;
          localStorage.setItem(environment.sessionAuth, JSON.stringify(session));
          return response;
        }
        )
      );
    }
  }

  private _filterValidateUbigeoCode(districts: any[]): any[] {
    return districts.filter(district => district.ubigeoCode !== '');
  }

  _filterDistrict(...arg): Observable<District[]> {
    const district = arg[0].normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1');
    return this.read('districtPartial', district, arg[1])
      .pipe(
        map(response => {
          return this._filterValidateUbigeoCode(response);
        }),
        catchError(() => {
          return of(null);
        })
      );
  }

  _filterDistrictProvince(...arg): Observable<District[]> {
    if (this.listDistrict.length) {
      return of(this.listDistrict.filter((item: any) => item.district.toLowerCase().includes(arg[0].toLowerCase())));
    } else {
      return this.read('district', arg[1])
        .pipe(
          map(response => {
            this.listDistrict = response;
            return response;
          }),
          catchError(_ => {
            return of(null);
          })
        );
    }
  }

  _filterEntity(...arg) {
    return arg[0].filter((item: any) => item.entityCode.includes(arg[1]) || item.entityName.toLowerCase().includes(arg[1].toLowerCase()));
  }

  _filterZone(...arg) {
    return arg[0].filter((item: any) => item[arg[1]].toLowerCase().includes(arg[2].toLowerCase()));
  }

  initialize() {
    this.listDistrict = [];
  }

  getAddress(result, addressesShoping): Observable<AddressOP> {
    if (result.stateAddress) {
      addressesShoping = addressesShoping.map((item, i) => {
        if (getIdAddress(item) === result.fullAddress) {
          return result;
        }
        return item;
      });
      return of({ address: result, addressesShopping: addressesShoping });
      // this.addAddressDad.emit();
    } else {
      if (result.fullAddress === 'new'
        && !addressesShoping.some(item => getIdAddress(item) === result.fullAddress)) {
        addressesShoping.push(result);
      }
      return of({ address: result, addressesShopping: addressesShoping });
      // this.addAddressDad.emit();
    }
  }
}
